import routerOptions0 from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}